import React, { useState } from 'react';
import ConfirmDialog from '../ConfirmDialog';

const ClubCard = ({ club, onView, onLeave }) => {
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);

  const handleLeaveClick = (e) => {
    e.stopPropagation();
    setShowLeaveConfirm(true);
  };

  const handleLeaveConfirm = () => {
    setShowLeaveConfirm(false);
    onLeave();
  };

  const getRoleLabel = (role) => {
    if (role === 'super_admin') return 'Owner';
    if (role === 'admin') return 'Admin';
    return 'Member';
  };

  const typeLabel = club.club_type === 'club' ? 'club' : 'group';

  return (
    <div className={`club-card club-card--${club.club_type || 'group'}`} onClick={onView}>
      <div className="club-card__header">
        <div className="club-card__title-row">
          <h3 className="club-card__title">{club.name}</h3>
        </div>
        <span className={`club-card__role club-card__role--${club.role}`}>
          {getRoleLabel(club.role)}
        </span>
      </div>

      {club.description && (
        <p className="club-card__description">{club.description}</p>
      )}

      <div className="club-card__stats">
        <div className="club-card__stat">
          <span className="club-card__stat-value">{club.member_count || 0}</span>
          <span className="club-card__stat-label">Members</span>
        </div>
      </div>

      <div className="club-card__footer">
        <button className="btn-view" onClick={(e) => { e.stopPropagation(); onView(); }}>
          View {club.club_type === 'club' ? 'Club' : 'Group'}
        </button>
        {club.role !== 'super_admin' && (
          <button className="btn-leave" onClick={handleLeaveClick}>
            Leave
          </button>
        )}
      </div>

      <ConfirmDialog
        isOpen={showLeaveConfirm}
        title={`Leave ${typeLabel}`}
        message={`Are you sure you want to leave this ${typeLabel}?`}
        confirmText="Leave"
        cancelText="Cancel"
        variant="warning"
        onConfirm={handleLeaveConfirm}
        onCancel={() => setShowLeaveConfirm(false)}
      />
    </div>
  );
};

export default ClubCard;
